module.exports = {
  "bottom-border": {
    "borderBottomWidth": "1",
    "borderColor": "#e5e5e8"
  },
  "dof-minibar": {
    "width": "750",
    "display": "inline-flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "stretch"
  },
  "isFixed": {
    "position": "fixed",
    "top": 0,
    "left": 0
  },
  "left": {
    "width": "160",
    "height": "88",
    "paddingLeft": "32",
    "justifyContent": "center"
  },
  "middle-title-wrapper": {
    "flex": 1,
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "middle-title": {
    "fontFamily": "PingFangSC-Medium",
    "lines": 1,
    "textOverflow": "ellipsis",
    "fontSize": "32",
    "textAlign": "center",
    "letterSpacing": 0,
    "fontWeight": "600"
  },
  "middle-sub-title": {
    "fontFamily": "PingFangSC-Medium",
    "width": "390",
    "lines": 1,
    "textOverflow": "ellipsis",
    "fontSize": "20",
    "textAlign": "center",
    "letterSpacing": 0
  },
  "right": {
    "width": "160",
    "minWidth": "84",
    "height": "88",
    "paddingRight": "32",
    "alignItems": "flex-end",
    "justifyContent": "center"
  },
  "left-button": {
    "width": "58",
    "height": "58"
  },
  "right-button": {
    "width": "58",
    "height": "58"
  },
  "icon-text": {
    "fontSize": "28",
    "color": "#1e2e37"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-57c74639!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-minibar/index.vue
// module id = 479
// module chunks = 0 1